var map = {
	"./ Cognitive.svg": 1297,
	"./APEL.svg": 1298,
	"./Anxiety.svg": 1299,
	"./AssistiveDevices.svg": 1300,
	"./IADL.svg": 1301,
	"./InterpersonalSkills.svg": 1302,
	"./LL.svg": 1303,
	"./Leisure.svg": 1304,
	"./Mobility.svg": 1305,
	"./PersonalManagement.svg": 1306,
	"./PhysicalNeuro.svg": 1307,
	"./SadArtboard.svg": 1308,
	"./Sensory.svg": 1309,
	"./Training.svg": 1310,
	"./UpperLimb.svg": 1311,
	"./VisualPerceptual.svg": 1312,
	"./Work.svg": 1313,
	"./alernativeAC.svg": 1314,
	"./articulation.svg": 1315,
	"./basic_concepts_icon.svg": 1316,
	"./behaviour.svg": 1317,
	"./boundries.svg": 1318,
	"./brain.svg": 1319,
	"./cognition.svg": 1320,
	"./conflict.svg": 1321,
	"./conflict2.svg": 1322,
	"./conversationSkills.svg": 1323,
	"./depression.svg": 1324,
	"./discourse.svg": 1325,
	"./emotions.svg": 1326,
	"./family.svg": 1327,
	"./fine_motor_icon.svg": 1328,
	"./fluency.svg": 1329,
	"./gross_motor_icon.svg": 1330,
	"./happySadFace.svg": 1331,
	"./language.svg": 1332,
	"./life_skills.svg": 1333,
	"./playskills.svg": 1334,
	"./playskills2.svg": 1335,
	"./pragmatics.svg": 1336,
	"./readingAndSpelling.svg": 1337,
	"./resonance.svg": 1338,
	"./scholastic_icon.svg": 1339,
	"./senseOfSelf.svg": 1340,
	"./sensory_icon.svg": 1341,
	"./social_skills.svg": 1342,
	"./speechProduction.svg": 1343,
	"./undefined.svg": 1344,
	"./visual_perception_icon.svg": 1345,
	"./voice.svg": 1346,
	"./waving.svg": 1347,
	"./waving2.svg": 1348
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories ^\.\/.*$
// module id = 136
// module chunks = 0